import styled from 'styled-components';

export default styled.div`
  box-sizing: border-box;
  padding: 10px;
  @media (min-width: 330px) {
    padding: 20px;
  }
`;
